import { render, staticRenderFns } from "./setLinkModalComp.vue?vue&type=template&id=2d82c51f&scoped=true"
import script from "./setLinkModalComp.vue?vue&type=script&lang=js"
export * from "./setLinkModalComp.vue?vue&type=script&lang=js"
import style0 from "./setLinkModalComp.vue?vue&type=style&index=0&id=2d82c51f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d82c51f",
  null
  
)

export default component.exports